import { createUseStyles } from 'react-jss';
import type { Theme } from '@wds/styles';

const useStyles = createUseStyles(
  ({ spacing, palette, border, radius, breakpoints }: Theme) => ({
    wrapper: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      [`@media (max-width: ${breakpoints.sm}px), (max-height: ${breakpoints.sm}px)`]: {
        position: 'relative',
        top: spacing[7],
      },
    },
    innerWrapper: {
      maxWidth: '550px',
    },
    title: {
      '& *': {
        lineHeight: '1.3',
      },
    },
    outerBox: {
      border: border.main,
      borderRadius: radius.small,
      backgroundColor: palette.background.light,
    },
    content: {
      '& p': {
        lineHeight: '1.4',
        margin: 0,
      },
    },
  })
);

export default useStyles;
